import React, { useEffect, useState } from 'react';
import '../styles/Navigation.css';

const Navigation = () => {
  const [currentPath, setCurrentPath] = useState('');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  useEffect(() => {
    setCurrentPath(window.location.pathname);
    
    // Update active link when route changes (for SPA navigation)
    const handleRouteChange = () => {
      setCurrentPath(window.location.pathname);
      setMobileMenuOpen(false); // Close mobile menu on navigation
    };
    
    window.addEventListener('popstate', handleRouteChange);
    return () => {
      window.removeEventListener('popstate', handleRouteChange);
    };
  }, []);
  
  // Function to determine if link is active
  const isActive = (path) => {
    if (path === '/') {
      return currentPath === path;
    }
    // For non-root paths, check if current path includes the given path
    return currentPath.includes(path);
  };
  
  // Check if we're at the home page with hash anchor
  const isContactActive = () => {
    return window.location.hash === '#Contact-form';
  };

  // Toggle mobile menu
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  // Close mobile menu when a link is clicked
  const handleLinkClick = (e) => {
    setMobileMenuOpen(false);
    
    // Vérifier si le lien pointe vers la section de contact
    if (e.target.getAttribute('href') === '/#Contact-form') {
      e.preventDefault();
      
      if (window.location.pathname !== '/') {
        window.location.href = '/#Contact-form';
      } else {
        const contactSection = document.getElementById('Contact-form');
        if (contactSection) {
          contactSection.scrollIntoView({ behavior: 'smooth' });
        }
        window.history.pushState(null, '', '/#Contact-form');
      }
    }
  };
  
  return (
    <header className="header"> 
      <div className="logo-container"> 
         <a href='/'>
       <img 
          src="/assets/images/logo.png" 
          alt="LG Logo" 
          className="logo" 
        />
        </a>
      </div>
      
      <nav className={`main-nav ${mobileMenuOpen ? 'show' : ''}`}>
        <a href="/" className={`nav-link ${isActive('/') ? 'yellow' : 'blue'}`} onClick={handleLinkClick}>QUI SOMMES NOUS</a>
        <a href="/products/EXCAVATOR" className={`nav-link ${isActive('/products/EXCAVATOR') ? 'yellow' : 'blue'}`} onClick={handleLinkClick}>PELLES</a>
        <a href="/products/MINI-EXCAVATOR" className={`nav-link ${isActive('/products/MINI-EXCAVATOR') ? 'yellow' : 'blue'}`} onClick={handleLinkClick}>MINI-PELLES</a>
        <a href="/products/GRADER" className={`nav-link ${isActive('/products/GRADER') ? 'yellow' : 'blue'}`} onClick={handleLinkClick}>NIVELEUSE</a>
        <a href="/products/Bulldozer" className={`nav-link ${isActive('/products/Bulldozer') ? 'yellow' : 'blue'}`} onClick={handleLinkClick}>BULLDOZERS</a>
        <a href="/products/LOADER" className={`nav-link ${isActive('/products/LOADER') ? 'yellow' : 'blue'}`} onClick={handleLinkClick}>CHARSEUSES</a>
        <a href="/#Contact-form" className={`nav-link ${isContactActive() ? 'yellow' : 'blue'}`} onClick={handleLinkClick}>CONTACT</a>
      </nav>
      
      <button className="mobile-menu-button" onClick={toggleMobileMenu} aria-label="Toggle menu">
        {mobileMenuOpen ? (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        )}
      </button>
    </header>
  );
};

export default Navigation;